// extracted by mini-css-extract-plugin
export var table = "table-module--table--6dcb1";
export var tableOuter = "table-module--tableOuter--5f146";